import React, { useEffect, useState } from 'react'

import { Button, Calendar, Popover, PopoverContent, PopoverTrigger } from './shadcn-ui'

interface DatePickerProps {
  className?: string
  selectedDate: Date | null // Single date or null
  disableStartDate?: Date | null
  onDateChange: (date: any) => void // Accepts a single date or null
  id?: string
  disabled?: string | 'none'
}

const DatePicker: React.FC<DatePickerProps> = ({ disabled, id, className, disableStartDate, selectedDate, onDateChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [date, setDate] = useState<Date | null>(selectedDate) // Local state for selected date

  // Update local date state when selectedDate prop changes
  useEffect(() => {
    setDate(selectedDate)
  }, [selectedDate])

  const handleDateChange = (selectedDate: any) => {
    setDate(selectedDate) // Update local date state
    onDateChange(selectedDate) // Call parent function with selected date
    setIsOpen(false) // Close the popover after selecting the date
  }

  return (
    <div
      className={`relative ${className}`}
      id={id}
    >
      <Popover
        open={isOpen}
        onOpenChange={setIsOpen}
      >
        <PopoverTrigger asChild>
          <Button
            className="w-full border border-gray-300 text-left text-sm font-normal"
            color="muted"
            variant="text"
          >
            {date ? date.toLocaleDateString() : 'Select Date'}
          </Button>
        </PopoverTrigger>

        <PopoverContent className="w-full p-4">
          <Calendar
            captionLayout="dropdown-buttons"
            className="rounded-lg"
            defaultMonth={date || new Date()}
            fromYear={date !== null ? date.getFullYear() - 100 : new Date().getFullYear() - 100}
            mode="single"
            selected={date !== null ? date : undefined}
            toYear={date !== null ? date.getFullYear() + 100 : new Date().getFullYear() + 100}
            disabled={
              disabled === 'before'
                ? (dat: Date) => dat.getTime() < (disableStartDate || new Date()).getTime()
                : disabled === 'all'
                  ? () => true
                  : false
            }
            onSelect={handleDateChange}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default DatePicker
